import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_URL = `${API_BASE_URL}/api/admin/testimonials`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getTestimonials = async (params = {}) => {
  try {
    const response = await api.get('/api/admin/testimonials', { params });
    // Handle the paginated response structure
    if (response.data && response.data.data) {
      return response.data.data; // Return the actual testimonials array
    }
    return response.data || [];
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch testimonials');
  }
};

export const getTestimonialById = async (id) => {
  try {
    const response = await api.get(`/api/admin/testimonials/${id}`);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error fetching testimonial:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch testimonial');
  }
};

export const createTestimonial = async (testimonialData) => {
  try {
    const response = await api.post('/api/admin/testimonials', testimonialData);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error creating testimonial:', error);
    throw new Error(error.response?.data?.detail || 'Failed to create testimonial');
  }
};

export const updateTestimonial = async (id, testimonialData) => {
  try {
    const response = await api.put(`/api/admin/testimonials/${id}`, testimonialData);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error updating testimonial:', error);
    throw new Error(error.response?.data?.detail || 'Failed to update testimonial');
  }
};

export const deleteTestimonial = async (id) => {
  try {
    const response = await api.delete(`/api/admin/testimonials/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting testimonial:', error);
    throw new Error(error.response?.data?.detail || 'Failed to delete testimonial');
  }
};

export const syncGoogleReviews = async (numReviews = 20) => {
  try {
    const response = await api.get(`/api/admin/testimonials/run-google-reviews-sync?num_reviews=${numReviews}`);
    return response.data;
  } catch (error) {
    console.error('Error syncing Google reviews:', error);
    throw new Error(error.response?.data?.detail || 'Failed to sync Google reviews');
  }
};

export const syncGoogleReviewsWait = async (numReviews = 20) => {
  try {
    const response = await api.get(`/api/admin/testimonials/run-google-reviews-sync-wait?num_reviews=${numReviews}`);
    return response.data;
  } catch (error) {
    console.error('Error syncing Google reviews:', error);
    throw new Error(error.response?.data?.detail || 'Failed to sync Google reviews');
  }
};